import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'
import { getAppointmentId, getSoapId } from '~/store/reducers/soap'

/**
 * Gathers all context needed for summary handling decisions.
 * Centralizes context gathering to reduce repetition.
 */
export const useSummaryContext = () => {
  const { pathname } = useLocation()
  const currentAppointmentId = useSelector(getAppointmentId) ?? null
  const soapId = useSelector(getSoapId)
  const isOnSoapPage = pathname.includes('/soap/')

  const summariesFTEnabled = useSelector(
    getFeatureToggle(FeatureToggle.AUDIO_RECORDER_SUMMARIES),
  )

  return {
    pathname,
    currentAppointmentId,
    soapId,
    isOnSoapPage,
    summariesFTEnabled,
  }
}
